import React, { useState } from 'react';
import { Button, TextField, Card, Box } from "@material-ui/core";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import ArrowForwardRounded from "@material-ui/icons/ArrowForwardRounded";
import { useStyles } from '../../styles/styles';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import logo from "../../logo.png";
import { Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import Grid from "@material-ui/core/Grid";
import { LoginAction } from '../../redux/actions/AuthActions';

import { useHistory, Link } from 'react-router-dom';
const styles = {
    root: {
        backgroundColor: 'transparent !important',
        boxShadow: 'none',
        paddingTop: '25px',
        color: '#FFFFFF'
    },
    centerItemLogin: {
        flex: "auto",
        top: "15%",
        position: "relative",
        left: "33.33%",
        right: "33.33%",
        width: "33.33%",
        '@media (max-width: 500px)': {
            left: "16.67%",
            right: "16.67%",
            width: "90%",
        },
        marginTop:"10%",
    },
    centerWithoutTop:{
        flex: "auto",
        position: "relative",
        left: "33.33%",
        right: "33.33%",
        width: "33.33%",
        '@media (max-width: 500px)': {
            left: "5%",
            right: "5%",
            width: "90%",
        },
    },
    cardItem: {
        paddingTop: "30px",
    },
    primary: {
        color: "#67a8e4",
    },
    customFail: {
        color: "#ef5350",
    },
    customSuccess: {
        color: "#4caf50",
    },
    fullWidth: {
        width: "80%",
        marginBottom: "25px",
        marginTop: "20px",
    },
    customButton: {
        marginTop: "15px",
        marginBottom: "30px",
        backgroundColor: "#67a8e4",
        textTransform: "Capitalize",
        clear: "both",
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "30px",
        paddingRight: "30px",

        "&:hover": {
            background: "#67a8e4",
        },
    },
    customButtonLeft: {
        float: "right",
        marginRight: "10%",
    },
    customClear: {
        position: "relative",
        top: "40%",
        clear: "both",
        color: "#404346",
        fontSize: "16px",
    },
    customLinkDark: {
        color: "#404346",
        textDecoration: "none",
    },
    roundIcon: {
        backgroundColor: "white",
        borderRadius: "50%",
        color: "#67a8e4",
    },
    customLink: {
        color: "#fff",
        textDecoration: "none",
    },
    link_label:{
        color:'#fff'
    }


}



function WelcomeComponent(props) {

    const history = useHistory();
    const { classes } = props;
    

    
    



    if (sessionStorage.getItem('user-token') != null) {
        return <Redirect to='/home' />
    }


    return (
        <>        
            <div className={classes.centerItemLogin}>
            
            
                <Grid container columns={{md: 12 }}>
            
                
                    <Grid item xs={2} sm={4} md={4}>
                        < Box
                            component="img"
                            sx={{
                                height: 70,
                                width: 400,
                                minHeight: { xs: 40, md: 70 },
                                maxHeight: { xs: 40, md: 167 },
                                maxWidth: { xs: 233, md: 400 },
                                minWidth: { xs: 233, md: 400 },
                            }}
                            alt="DOED"
                            src={logo}
                        />
                    </Grid>
                 
                </Grid>
                
                </div>
            <div className={classes.centerWithoutTop}>

                <h2 >
                    <b className={classes.primary}>
                        Online Application System</b>
                </h2>
            <Grid container  columns={{ md: 12 }}>
                <Grid item xs={12} md={6}>
                    <div className={classes.linkContainer}>
                            <Link to="/staff/login" className={classes.customLink}><Button startIcon={<ArrowBackRounded className={classes.roundIcon} />} className={[classes.customButton, classes.link_label]}>DOED's STAFF </Button></Link>
                    </div>
                </Grid>
                <Grid item xs={12} md={6}>
                    <div className={classes.linkContainer}>
                            <Link to="/user/login" className={classes.customLink}><Button endIcon={<ArrowForwardRounded className={classes.roundIcon} />} className={[classes.customButton, classes.link_label]}> DOED's CLIENT</Button></Link>
                    </div>
                </Grid>
                </Grid>
                </div>
                  
         
        </>   
          
    )
}

export default withStyles(styles)(WelcomeComponent);
